import React from "react";

import { Img, Text } from "components";
import { formatCurrency } from "../../helpers/number";
import { parseImageDescriptionToHTML } from "../../helpers/string.mjs";

const ProductItem = (props) => {

  return (
    <>
      <div className={props.className}>
        <div
          onClick={props.onSelect}
          className="h-[250px] relative border rounded-lg w-full cursor-pointer" style={{ backgroundColor: 'white' }}>
          <Img
            className={`m-auto ${props?.image ? "object-contain" : "object-cover"} rounded-lg w-full h-full`}
            src={props?.image ?? "images/abstract_placeholder.jpeg"}
            alt="rectangleTwentyThree"
          />
        </div>

        <Text
          className="mt-[8px] text-base text-zinc-700 tracking-[0.15px]"
          size="txtInterRegular16BlueA700"
        >
          {props?.name}
        </Text>
        <span className="mt-[8px] text-base text-zinc-700 tracking-[0.15px]"
              size="txtInterRegular16BlueA700" dangerouslySetInnerHTML={{
          __html: parseImageDescriptionToHTML(`${props?.description?.substring(0, 110)}${props?.description?.length > 110 ? '...' : ''}`)
        }} />
        {/*<Text*/}
        {/*  className="mt-[8px] text-base text-zinc-700 tracking-[0.15px]"*/}
        {/*  size="txtInterRegular16BlueA700"*/}
        {/*>*/}
        {/*  {props?.description?.substring(0, 110)}{props?.description?.length > 110 ? '...' : ''}*/}
        {/*</Text>*/}

        <div className="flex flex-row items-start justify-start mt-[16px] whitespace-nowrap">
          <Text
            className="text-blue_gray-700 mt-[4px] text-xs tracking-[0.40px]"
            size="txtInterRegular12"
          >
            {props?.currency ?? "TZS"}
          </Text>
          <Text
            className="ml-[3px] text-black-900_dd text-xl tracking-[0.15px]"
            size="txtInterMedium20"
          >
            {formatCurrency(props?.amount)}
          </Text>
        </div>

        <div style={{ padding: '8px 16px', backgroundColor: '#191919', borderRadius: 48 }} onClick={props.onAddToBasket}
             className="cursor-pointer sm:hidden mt-[16px] flex flex-row items-center">
          <Img
            className="h-6 rounded-[33px] mr-3 text-indigo-A700"
            src="images/img_add.svg"
            alt="add"
          />
          {/*<div className="flex flex-col items-center justify-start">*/}
          {/*<Text*/}
          {/*  className="text-sm text-white-A700_dd tracking-[0.25px]"*/}
          {/*  size="txtInterRegular14WhiteA700dd"*/}
          {/*>*/}
          {/*  {props?.bodytwo}*/}
          {/*</Text>*/}
          <Text
            className="text-sm text-white-A700 tracking-[0.25px]"
            size="txtInterRegular14WhiteA700dd"
          >
            {props?.actionText ?? 'View more'}
          </Text>
          {/*</div>*/}
        </div>
      </div>
    </>
  );
};

ProductItem.defaultProps = {
  productname: "",
  productdescription: "",
  price: "TZS",
  productprice: "0",
  bodytwo: "Add to basket"
};

export default ProductItem;
